import FilledButton from "@/components/button/filled-button/filled-button";
import { OutlinedButton } from "@/components/button/outlined-button";
import { PageContainer } from "@/components/container/page-container";
import { ListRenderer } from "@/components/list/list-renderer";
import { PageTitleComponent } from "@/components/page-title";
import { cn } from "@/utils/cn";
import { IonSkeletonText } from "@ionic/react";
import { AisleFilterTabButtons } from "../../components/aisle-filter-tab-buttons";
import EmptyShopList from "../../components/empty-shop-list";
import ShoppingList from "../../components/shopping-list";
import { useShopList } from "../../hooks/use-shop-list";

export default function ShopListPage() {
  const {
    isLoading,
    tickedItems,
    selectedAisle,
    handleToggleItem,
    handleMarkAllAsBought,
    handleResetList,
    isUpdating,
    groupedIngredients,
    ingredientCategories,
    selectedIngredients,
    error,
  } = useShopList();

  return (
    <PageContainer
      className="px-4 gap-6 app-bar-bottom-padding overflow-y-auto no-scrollbar pb-32"
      title="My Shopping List"
    >
      <PageTitleComponent description="Everything you need for the week, grouped by aisle for an easier, faster shop." />

      <AisleFilterTabButtons
        aisles={ingredientCategories}
        selectedAisle={selectedAisle}
        groupedIngredients={groupedIngredients}
      />
      <ListRenderer
        items={groupedIngredients.get(selectedAisle ?? "")}
        isLoading={isLoading}
        isError={!!error}
        errorComponent={
          <div className="w-full flex-1 flex flex-col justify-center items-center gap-4">
            {error?.message}
          </div>
        }
        loadingComponent={
          <div className="w-full flex-1 flex flex-col gap-4">
            <IonSkeletonText animated className="h-12 rounded-xl" />
            <IonSkeletonText animated className="h-12 rounded-xl" />
            <IonSkeletonText animated className="h-64 rounded-xl" />
          </div>
        }
        emptyComponent={<EmptyShopList />}
      >
        <ShoppingList
          selectedIngredients={selectedIngredients ?? []}
          tickedItems={tickedItems}
          handleToggleItem={handleToggleItem}
        />
      </ListRenderer>
      <div className={cn("w-[450px] max-w-full", "flex gap-3 pt-4")}>
        <OutlinedButton
          text="Reset List"
          disabled={isUpdating}
          onClick={handleResetList}
          className="flex-1 text-sm"
        />
        <FilledButton
          text="Mark All as Bought"
          onClick={handleMarkAllAsBought}
          color="dark"
          className="flex-1 text-sm"
          disabled={isUpdating}
        />
      </div>
    </PageContainer>
  );
}
